import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { GridkyAreas } from './ea-gridky-header/ea-gridky-header.component';
import { EaGridkyService } from './ea-gridky.service';

@Component({
    selector: 'ea-gridky',
    templateUrl: './ea-gridky.component.html',
    styleUrls: ['./ea-gridky.component.scss'],
    providers: [EaGridkyService],
    standalone: false
})
export class EaGridkyComponent implements OnInit {
  @Input() type;
  loading = false;

  constructor(public gridkyService: EaGridkyService) {
    this.gridkyService.searchProductSubject.subscribe(
      () => (this.loading = true),
    );
    this.gridkyService.productChanged.subscribe(() => (this.loading = false));
  }

  ngOnInit() {}

  get product() {
    return this.gridkyService.product || undefined;
  }

  get selectedArea() {
    return this.gridkyService.filters.selectedArea || undefined;
  }

  get userRp() {
    return this.gridkyService.userRp;
  }

  get url() {
    return this.gridkyService.urlDocuments;
  }
}
